import {
  takeLatest, put, call,
} from 'redux-saga/effects';
import api from 'store/api';
import { URL } from '../../../constants/url';
import actionTypes from '../actionTypes';

export function* getRefSettings() {
  try {
    const res = yield call(api, {
      method: 'get',
      url: URL.REF_SETTINGS,
    });
    const { data } = res;
    yield put({ type: 'GET_REF_SETTINGS_SUCCESS', data });
  } catch (e) {
    yield put({ type: 'GET_REF_SETTINGS_ERROR' });
  }
}

export default function* listener() {
  yield takeLatest(actionTypes.GET_REF_SETTINGS, getRefSettings);
}
